import * as XLSX from '@e965/xlsx';
import type { Shipping } from '../types';
import { getShippingCompanyLabel, getStatusInfo } from '../types';

/**
 * Format date for Excel export
 */
function formatDate(dateString: string | null): string {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString('en-CA'); // YYYY-MM-DD
  } catch {
    return '';
  }
}

/**
 * Export shippings to Excel format using SheetJS
 */
export function exportShippingsToExcel(shippings: Shipping[], filename?: string): void {
  const headers = [
    'Slip #',
    'Quote #',
    'Project Name',
    'Status',
    'Company',
    'Tracking #',
    'Shipped Date',
    'Received Date',
    'Ship To Site',
    'Attention To',
    'Prepared By',
    'Verified By',
    'Created At',
  ];

  const rows = shippings.map((s) => [
    s.slipNumber || '',
    s.quoteNumber || '',
    s.quoteProjectName || '',
    getStatusInfo(s.status).label,
    getShippingCompanyLabel(s.shippingCompany),
    s.trackingNumber || '',
    formatDate(s.shippedDate),
    formatDate(s.receivedDate),
    s.shipToSiteName || '',
    s.attentionTo || '',
    s.preparedByName || '',
    s.verifiedByName || '',
    formatDate(s.createdAt),
  ]);

  const data = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Set column widths
  ws['!cols'] = [
    { wch: 12 }, // Slip #
    { wch: 12 }, // Quote #
    { wch: 25 }, // Project Name
    { wch: 15 }, // Status
    { wch: 15 }, // Company
    { wch: 20 }, // Tracking #
    { wch: 12 }, // Shipped Date
    { wch: 12 }, // Received Date
    { wch: 20 }, // Ship To Site
    { wch: 18 }, // Attention To
    { wch: 18 }, // Prepared By
    { wch: 18 }, // Verified By
    { wch: 12 }, // Created At
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Shippings');

  const exportFilename = filename || `shippings_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, exportFilename);
}
